// extracted by mini-css-extract-plugin
export var addressFields = "_j8-0";
export var animationContainer = "_j8-1";
export var footer = "_j8-2";
export var lineItems = "_j8-3";
export var modalContent = "_j8-4";
export var orderName = "_j8-5";
export var strong = "_j8-6";
export var warning = "_j8-7";